var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInbox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 7C5 5.73684 5.73684 5 7 5H17C18.2632 5 19 5.73684 19 7V17C19 18.2632 18.2632 19 17 19H7C5.73684 19 5 18.2632 5 17V7ZM3 7V17C3 19.2456 4.75439 21 7 21H17C19.2456 21 21 19.2456 21 17V7C21 4.75439 19.2456 3 17 3H7C4.75439 3 3 4.75439 3 7ZM8 14C8 16.2105 9.78947 18 12 18C14.2105 18 16 16.2105 16 14C16 13.4561 15.5439 13 15 13C14.4561 13 14 13.4561 14 14C14 15.2281 13.2281 16 12 16C10.7719 16 10 15.2281 10 14C10 13.4561 9.54386 13 9 13C8.45614 13 8 13.4561 8 14ZM9 13H4C3.45614 13 3 13.4561 3 14C3 14.5439 3.45614 15 4 15H9C9.54386 15 10 14.5439 10 14C10 13.4561 9.54386 13 9 13ZM20 13H15C14.4561 13 14 13.4561 14 14C14 14.5439 14.4561 15 15 15H20C20.5439 15 21 14.5439 21 14C21 13.4561 20.5439 13 20 13ZM9 14H4V16.9474C4 18.7193 5.2807 20 7.05263 20H16.9474C18.7193 20 20 18.7193 20 16.9474V14H15C15 15.6491 13.6491 17 12 17C10.3509 17 9 15.6491 9 14Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInbox);
export default __webpack_public_path__ + "static/media/inbox.3a66e85a.svg";
export { ForwardRef as ReactComponent };